<template>
  <div >
    <board-filter-link v-if="redraw"
      :filterLayout="filterLayout"
      :filterData="filterSet.filter"
      :paginationData="filterSet.page"
    ></board-filter-link>
    <board-list-link
      :listLayout="listLayout"
      :boardData="List"
      :paginationData="filterSet.page"
      :boardType="boardType"
    ></board-list-link>
    <pagination-link
      :paginationLayout="paginationLayout"
      :paginationData="filterSet.page"
      :listLength="List.length"
    ></pagination-link>
  </div>
</template>

<script>
import BoardFilterLink from "@/components/board/BoardFilterLink";
import BoardListLink from "@/components/board/BoardListLink";
import PaginationLink from "@/components/board/PaginationLink";
import filterMixins from "@/mixins/filterMixins";
import listMixins from "@/mixins/listMixins";
import alertMixins from "@/mixins/alertMixins";
import boardFilterUtil from "@/components/board/boardFilterUtil";
import boardTemplateUtil from "@/components/board/boardTemplateUtil";
import util from "@/mixins/util";
import DeleteClass from "@/mixins/deleteClass";

const { filterConfig } = boardFilterUtil;
export default {
  name: "BoardListComponent",
  mixins: [
    alertMixins,
    filterMixins,
    listMixins,
    boardFilterUtil,
    boardTemplateUtil,
  ],
  components: { BoardFilterLink, BoardListLink, PaginationLink },
  inject: ["changeLoading"],
  provide() {
    return {
      setPage: this.setPage,
      setFilter: this.setFilter,
      boardListSetData: this.setData,
      boardListDelete: this.runDeleteConfirm,
    };
  },

  props: {
    boardType: "",
    userKey: "",
    ssamsKey: "",
  },
  data() {
    return {
      listLayout: "",
      listApiParamSet: {},
      filterLayout: "",
      paginationLayout: "",
      paginationType: "",
      getFunc: "",

      deleteFunc: "",
      deleteApiParamsSet: {},
      deleteSuccessType: 1,
      deleteFailTypes: {},
      deleteErrorTypes: [],
      keyName: "",

      selectArr: [],
      DeleteClass: null,

      deleteIndex: 0,
      deleteLastIndex: 0,

      filterDate: "",
      filterSort: false,
      redraw:true,
    };
  },
  created() {
    this.setFilterConfig(filterConfig);
    if(this.boardType==='ktalkFixModal' || this.boardType==='contentFixModal' ){
      this.setParserType("vuex", this.$route.fullPath);
    }else if(this.boardType==='productSelect' ){
      this.setParserType("vuex", this.$route.path);
    }else{
      this.setParserType("url", this.$route.fullPath);
    }
    this.initConfig();
    this.newDeleteClass();
  },
  mounted() {
    this.getList(true);
  },
  beforeDestroy() {},
  destroyed() {},
  computed: {},
  methods: {
    initConfig() {
      let boardTemplateConfig = this.returnBoardTemplateConfig(this.boardType);
      this.listLayout = boardTemplateConfig.listLayout;
      this.filterLayout = boardTemplateConfig.filterLayout;
      this.paginationLayout = boardTemplateConfig.paginationLayout;
      let boardFilterConfig = this.returnBoardFilterConfig(this.boardType);
      this.listApiParamSet = boardFilterConfig.listApiParamSet;
      this.paginationType = boardFilterConfig.paginationType;
      this.getFunc = boardFilterConfig.getFunc;
      this.deleteFunc = boardFilterConfig.deleteFunc;
      this.deleteApiParamsSet = boardFilterConfig.deleteApiParamsSet;
      this.deleteSuccessType = boardFilterConfig.deleteSuccessType;
      this.deleteFailTypes = boardFilterConfig.deleteFailTypes;
      this.keyName = boardFilterConfig.keyName;
      boardFilterConfig.pageRow && boardFilterConfig.pageRow != 10
        ? (this.filterSet.page.size = boardFilterConfig.pageRow)
        : "";

      let listOptions = {
        url: this.$api.$board[this.getFunc],
        defaultParams: this.listApiParamSet,
      };
      if (!util.isEmpty(this.ssamsKey) && this.boardType === 'ssamsContent' || this.boardType === 'ssamsKoreanTalk' || this.boardType === 'ssamsContentFix' || this.boardType === 'ssamsKoreanTalkFix') {
        listOptions.defaultParams.sid = this.ssamsKey;
      }

      this.initList("api", listOptions);
    },
    setData(key, value) {
      this[key] = value;
    },
    newDeleteClass() {
      let deleteOptions = {
        func: this.$api.$board[this.deleteFunc],
        apiParamSet: this.deleteApiParamsSet,
        keyName: this.keyName,
        errorTypes: this.deleteErrorTypes,
        successType: this.deleteSuccessType,
        afterFunc: this.deleteAfterFunc,
      };
      this.DeleteClass = new DeleteClass(deleteOptions);
    },
    runDeleteConfirm() {
      if (this.selectArr.length === 0) {
        this.errorAlert("목록을 선택해주세요.");
        return false;
      }
      this.createConfirm({
        content: "정말 삭제하시겠습니까?",
        confirm: () => {
          this.deleteIndex = 0;
          this.deleteLastIndex = this.selectArr.length - 1;
          this.runDelete();
        },
      });
    },
    runDelete() {
      this.changeLoading(true);
      this.DeleteClass.runDelete(this.selectArr[this.deleteIndex]);
    },
    deleteAfterFunc() {
      if (this.deleteIndex < this.deleteLastIndex) {
        this.deleteIndex = this.deleteIndex + 1;
        this.runDelete();
      } else {
        this.changeLoading(false);
        this.createAlert({
          content: "삭제되었습니다.",
          hide: () => {
            this.getList();
          },
        });
      }
    },


  },
  watch: {
    // 'boardType' : {
    //     deep : true,
    //     handler: function (val, oldVal) {
    //       if (val !== oldVal) {
    //         this.redraw = false;

    //         this.setFilterConfig(filterConfig);
    //         if(this.boardType==='ktalkFixModal' || this.boardType==='contentFixModal'){
    //           this.setParserType("vuex", this.$route.fullPath);
    //         }else{
    //           this.setParserType("url", this.$route.fullPath);
    //         }
    //         this.filterSet = {
    //             filter: {},
    //             page: {
    //                 page: 1,
    //                 size: 10,
    //                 total: 0,
    //             },
    //             sort: {},
    //         },
    //         this.initConfig();
    //         this.newDeleteClass();
    //         setTimeout(() => {
              
    //           this.redraw = true;
    //         }, 10);
    //         this.getList(true);
    //       }
    //     },
    // }
  },
};
</script>

<style scoped></style>
